import { useState } from "react";
import { motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import EtContactReflection from "@/components/contact/EtContactReflection";

 const EtModalContactReflection = ({ open, onClose }) => {
  // First Created - 01 Nov 2025
  // Author - Atul Pandey

  if (!open) return null;

  return (
    <div role="dialog" aria-modal="true" className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60" />
      <motion.div
        className="relative w-full max-w-2xl mx-auto rounded-2xl bg-black/85 border border-white/10 shadow-xl overflow-hidden"
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
      >
        <button className="absolute top-3 right-3 p-2 rounded-lg bg-white/5 hover:bg-white/10" onClick={onClose}>
          <XMarkIcon className="h-6 w-6 text-gray-300" />
        </button>
        <EtContactReflection onDone={onClose} />
      </motion.div>
    </div>
  );
}

export default EtModalContactReflection
